<!-- 情绪尺子 -->
<template>
  <div>
    <div class="chat-card">
      <RatingSelector ref="RatingSelector" v-model="currentValue" :disable="!isCanEdit">
        <div class="what-link" @click.stop="sendEmotionalRuler" slot="rightTxt">
          为什么要使用情绪尺子？
        </div>
      </RatingSelector>
      <button v-if="isCanEdit" class="confirm-btn" @click="confirmFn">
        确定
      </button>
    </div>
    <!-- <div v-if="cardData.isShowTime" class="send-time">09月01日 16:29</div> -->
  </div>
</template>

<script>
import RatingSelector from '../../RatingSelector/index.vue'
export default {
  name: 'ChatText',
  props: {
    cardData: {
      type: Object,
      default() {
        return {
          isShowTime: true
        };
      }
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    }
  },
  components: {
    RatingSelector
  },
  data() {
    return {
      currentValue: 5
    };
  },
  created() {
  },
  mounted() {
    if(this.nextData?.step_data?.store?.moodScore) {
      let useData = this.nextData?.step_data?.store?.moodScore;
      this.currentValue = useData;
    }
  },
  methods: {
    // 提交数据
    confirmFn() {
      let useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: this.cardData.step_type,
                answer: {
                  val: this.currentValue
                },
              },
            ],
          },
          store: {
            moodScore: this.currentValue
          },
        },
      };
      this.$emit('confirmFn', useData);
    },
    // 什么是情绪尺子
    sendEmotionalRuler() {
      this.$emit('sendEmotionalRuler');
    }
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 100%;
  .what-link {
    float: right;
    color: #2a82e4;
    text-decoration: underline;
  }
}
.confirm-btn {
  width: 76px;
  height: 25px;
  border-radius: 12px;
  background: #3895ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.23px;
  color: #fff;
  border: none;
  margin: 10px auto 0;
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}
</style>
